export const gapQuestions = {
  "q-vision": {
    own: {
      en:
        "Your assessment of your own ability to communicate a vision and set directions for your team is higher than what others evaluate. This might be due to fact that you …",
      dk:
        "Du oplever selv du er bedre til at kommunikere en vision og skabe retning når du leder dine medarbejdere, end andre oplever. Det kan f.eks. skyldes at du …"
    },
    others: {
      en:
        "Others assess you to be better at communicating vision and set directions than you do. This might be because of the fact that you …",
      dk:
        "Andre oplever du er bedre til at kommunikere en vision og skabe retning end du selv oplever. Det kan f.eks. skyldes at du …"
    }
  },
  "q-authorisation": {
    own: {
      en:
        "Your ability to delegate responsibility and authorize others in your team is not so clear to others. It may be due to the fact that you …",
      dk:
        "Din evne til at delegere og autorise andre når du leder, er ikke så tydelig for andre. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you better at delegating and authorizing your team than you see yourself. That might be because of how/or what you …",
      dk:
        "Andre oplever du er bedre til at delegere og autorise dine medarbejdere, end du selv synes. Det kan skyldes at du …"
    }
  },
  "q-inspire-motivate-others": {
    own: {
      en:
        "You assess your own ability to inspire and motivate your team to be higher that what others see. It might be due to the fact that you …",
      dk:
        "Du oplever du er bedre til at inspirere dine medarbejdere gennem din kommunikation, end andre oplever. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others assess you to be better at motivate and inspire your team than you do yourself. This might be because of the fact that you …",
      dk:
        "Andre oplever at du er bedre til at inspirere andre gennem din kommunikation end du selv synes. Det skyldes muligvis at du …"
    }
  },
  "q-result-oriented": {
    own: {
      en:
        "Your focus on performance and results with clear goals, requirements and expectations, is perceived greater by yourself than by others. It may be due to the fact that you …",
      dk:
        "Dit fokus på performance og resultater som følge af klare mål, krav og forventninger, opleves større af dig selv end af andre. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you as having sufficient focus on performance and results. They find that you specify clear goals, requirements and expectations, to an extent that exceed you own perception. It may be due to the fact that you …",
      dk:
        "Andre oplever du har tilstrækkeligt fokus på performance og resultater. De oplever at du angiver klare mål, krav og forventninger, i højere grad som du selv synes. Det kan skyldes at du …"
    }
  },
  "q-recognition-feedback": {
    own: {
      en:
        "You find that your recognition of employee efforts and their positive behavior is greater than what others see. It may be due to the fact that you …",
      dk:
        "Du oplever selv at din anerkendelse af medarbejderes indsats og deres positive adfærd er større, end hvad andre får øje på. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you as both acknowledging and involved in your leadership, to a greater extent than you think yourself. It may be due to the fact that you …",
      dk:
        "Andre oplever du er både anerkendende og involverende i dit lederskab, i større grad som du selv synes. Det kan skyldes at du …Andre oplever din indsats for at opbygge en stærk gruppe gennem tillid, samarbejde og involverende handlinger er større end det du selv oplever. Det kan skyldes at du …"
    }
  },
  "q-teambuilding": {
    own: {
      en:
        "Your effort to build a strong group using trust, inviting to collaboration and involvement is greater than what others can see. It may be due to the fact that you …",
      dk:
        "Din indsats for at bygge en stærk gruppe gennem tillid, samarbejde og involverende handlinger er større end hvad andre kan få øje på. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others are experiencing your efforts to build a strong group through trust, collaboration and involvement  are greater than what you perceive yourself. It may be due to the fact that you …",
      dk:
        "Andre oplever din indsats for at opbygge en stærk gruppe gennem tillid, samarbejde og involverende handlinger er større end det du selv oplever. Det kan skyldes at du …"
    }
  },
  "q-persistence": {
    own: {
      en:
        "You see yourself stick to your convictions and be more persistent than others experience you. It may be due to the fact that you …",
      dk:
        "Du ser dig selv mere vedholdende og holden fast i dine meninger, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others see you more persistent and sticking up for your convictions - more so than you self do. This might be because of the fact that you …",
      dk:
        "Andre oplever dig mere vedholdende og insisterende, end du selv gør. Det kan skyldes at du …"
    }
  },
  "q-emotional-intelligence": {
    own: {
      en:
        "Your experience of how well you sense others emotional state of mind seem to be greater than what your surroundings perceive. It may be due to the fact that you …",
      dk:
        "Din oplevelse af hvor god din fornemmelse for andre er, synes at være større end det dine omgivelser opfatter. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience your care and feeling for others to be greater than you think of yourself. That might be because of how/ or what you …",
      dk:
        "Andre oplever din omsorg og fornemmelse for andre, til at være større end du selv synes. Det skyldes muligvis at du …"
    }
  },
  "q-resilience": {
    own: {
      en:
        "You  find yourself having more control over the workload and its influence on your mood and energy than others do. It may be due to the fact that you …",
      dk:
        "Du oplever selv at du har mere styr på arbejdsbyrden og dens indflydelse på dit humør og energi, end andre gør. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others find that you are in control of your workload and its influence on your mood and energy than you perceive. It may be due to the fact that you …",
      dk:
        "Andre oplever at du har godt styr på din arbejdsbyrde og dens indflydelse på dit humør og energi, end du selv oplever. Det kan skyldes at du …"
    }
  },
  "q-work-life-balance": {
    own: {
      en:
        "You believe you are better at balancing your time between work and leisure than what others see. It may be because of how you …",
      dk:
        "Du synes selv du er bedre til at balancere arbejde og fritid, end hvad andre kan få øje på. Det kan være på grund af at du …"
    },
    others: {
      en:
        "Others believe you are better at balancing work and leisure time than you think yourself. It may be due to  the fact that you …",
      dk:
        "Andre synes du er bedre til at balancere arbejde og fritid, end hvad du selv synes. Det skyldes muligvis at du …"
    }
  },
  "q-external-orientation": {
    own: {
      en:
        "Your ability to look at the outside world, seek inspiration and be holistic in your approach seems to be better than what others are experiencing. It may be due to the fact that you …",
      dk:
        "Din evne til at rette blikket imod omverdenen, søge inspiration og være helhedsorienteret synes at være bedre end hvad andre oplever. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others find that you better at being holistic and seeking inspiration in the world around you than you think of yourself. It may be due to the fact that you …",
      dk:
        "Andre oplever at du er bedre til at være helhedsorienteret og søge inspiration i verden omkring dig, end du selv synes. Det skyldes muligvis at du …"
    }
  },
  "q-dialogue": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },

  //TA
  "q-critical-parent": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },
  "q-caring-parent": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },

  "q-parent": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },

  "q-natural-child": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },

  "q-withdrawen-child": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  },

  "q-angry-child": {
    own: {
      en:
        "You think you are more open, accessible, and curious about your leadership role than others are experiencing. It may be due to the fact that you …",
      dk:
        "Du synes selv du er mere åben, tilgængelig og nysgerrig i din ledelsesrolle, end andre oplever dig. Det kan skyldes at du …"
    },
    others: {
      en:
        "Others experience you more accessible, curious and open than you see yourself. That might be due to the fact that you …",
      dk:
        "Andre oplever dig mere tilgængelig, nysgerrig og åben end du selv synes du er. Det skyldes muligvis at du …"
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/gapQuestions.js